import '../../Styles/FeedbackSection.css'
function FeedbackSection ({adviceList, resultatIalt}) {
    const boldPercentages = (text) => {
        const regex = /(\(\d+\.\d+%\))|(\d+\.\d+%)/g;
        return text.split(regex).map((part, index) =>
          regex.test(part) ? <span key={index} className="percentage-highlight">{part}</span> : part
        );
      };
      
    
    
    return (
        <>
              
            <div className="col-2 border border-dark border-end-0 fixed-width-column" style={{backgroundColor:'#001633'}} ><p style={{color:'white'}}>Resultatopgørelse</p></div>
            <div className="col-2 border border-dark border-end-0 fixed-width-column" style={{backgroundColor:'#001633'}}><p style={{color:'white'}}>Konto Beløb</p></div>
            <div className="col-1 border border-dark border-end-0 fixed-width-column" style={{backgroundColor:'#001633'}}><p style={{color:'white'}}>%</p></div>
            <div className="col-1 border border-dark border-end-0 fixed-width-column" style={{backgroundColor:'#001633'}}><p style={{color:'white'}}>HT</p></div>
            <div className="col-6 ps-5 fixed-width-column">
                

            
            <div style={{backgroundColor:"#001633"}} className="feedback-column">
                <p style={{color:"white"}}>Dit Resultat er: {resultatIalt? 
                    Intl.NumberFormat('dk-DK').format(-resultatIalt) + ' Kr.' : 
                    'N/A'}
                </p>
            </div>

            <div style={{color:"#FD6925"}} className="feedback-summary">
                Hermed er din rapport for perioden. Rapporten bygger på data fra din resultatopgørelse og dit budget, hvis du ønsker udvidet analyse kontakt EasyAdmin.
            </div>

            {adviceList && adviceList.length > 0 ? (
          adviceList.map((advice, index) => (
            <div key={index} className="feedback-advice">
              {boldPercentages(advice)}
            </div>
          ))
        ) : (
          <p>No advice available</p>
        )}

            <div className="feedback-column">
                <p>
                    Du skal altid have struktur og orden. Dine byggeledere skal følge den røde tråd. Husk denne måned at anerkend dine folk og afstem forventninger for den kommende periode. Det er vigtigt, du inkluderer dine medarbejdere, hvor det er relevant, og afstemmer forventninger.
                </p>
            </div>
        </div>
            
        
        </>
    )
}
export default FeedbackSection;